import PlusIcon from "assets/icons/PlusIcon";
import { useRef } from "react";

export interface AddCardProps {
  icon?: React.ReactNode;
  label?: string;
  onClick?: () => void;
}
export default function AddCard(props: AddCardProps) {
  const ref = useRef<any>(null);
  return (
    <div
      className="rounded-md aspect-video w-96 border-dashed-gray hover:border-dashed-blue py-5 px-4 transition-all cursor-pointer"
      onClick={props.onClick}
      ref={ref}
    >
      <div className="bg-white shadow-[0_0_10px_0px_rgba(0,0,0,0.2)] rounded-md h-full w-full flex flex-col gap-4 justify-center items-center">
        <div className="flex items-center justify-center h-1/2">{props.icon}</div>
        <div className="flex items-center justify-center gap-2">
          <PlusIcon color="#1062D0" scale={0.7} />
          <span className="text-blue-1">{props.label}</span>
        </div>
      </div>
    </div>
  );
}
